import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const DecisionType = iotsUtils.fromList(constants.transaction.review.decisionTypes);
